// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Tabs */
.horizontal-tabs {
  max-width: 100%;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 20px;
}

.tab-container {
  position: relative;
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar on Firefox */
  -ms-overflow-style: none; /* Hide scrollbar on IE/Edge */
}

.tab-container::-webkit-scrollbar {
  display: none; /* Hide scrollbar on Chrome/Safari */
}

.tab-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.tab-content-scrollable {
  height: calc(100% - 130px);
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/tabs.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iCAAiC,EAAE,4BAA4B;EAC/D,qBAAqB,EAAE,8BAA8B;EACrD,wBAAwB,EAAE,8BAA8B;AAC1D;;AAEA;EACE,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":["/* Sidebar Tabs */\n.horizontal-tabs {\n  max-width: 100%;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 20px;\n}\n\n.tab-container {\n  position: relative;\n  display: flex;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  scrollbar-width: none; /* Hide scrollbar on Firefox */\n  -ms-overflow-style: none; /* Hide scrollbar on IE/Edge */\n}\n\n.tab-container::-webkit-scrollbar {\n  display: none; /* Hide scrollbar on Chrome/Safari */\n}\n\n.tab-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.tab-content-scrollable {\n  height: calc(100% - 130px);\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
